var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { class: _vm.leftColClasses },
      [
        _c("toggle-switch", {
          staticClass: "mb-1",
          attrs: {
            id: _vm.id,
            name: _vm.name,
            disabled: _vm.loading || _vm.disabled,
          },
          on: { change: _vm.handleValueChange },
          model: {
            value: _vm.marketingFlag,
            callback: function ($$v) {
              _vm.marketingFlag = $$v
            },
            expression: "marketingFlag",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { class: _vm.rightColClasses }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.error,
              expression: "error",
            },
          ],
          staticClass: "invalid-feedback",
        },
        [_vm._v(_vm._s(_vm.i18n.errorMessage))]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "txt_privacy" }, [_vm._t("default")], 2),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }